import { z } from "zod";

const EditValueValidator = z.object({
  newValue: z.string().min(1, "Venligst fyll inn tekst for å endre verdien"),
});

export { EditValueValidator };
export type EditValueType = z.infer<typeof EditValueValidator>;
